/* eslint-disable
    eqeqeq,
    @typescript-eslint/no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import { Analytics } from '@trello/atlassian-analytics';
import { renderComponent } from '@trello/component-wrapper';
import { customFieldsId as CUSTOM_FIELDS_ID } from '@trello/config';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { PremiumFeature } from '@trello/product-features';
import { navigate } from '@trello/router/navigate';
import { GlobalThemeObserver } from '@trello/theme';
import { isUrl } from '@trello/urls';
import { importWithRetry } from '@trello/use-lazy-component';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { getBoardUrl } from 'app/scripts/controller/urls';
import { BUTLER_POWER_UP_ID } from 'app/scripts/data/butler-id';
import { LegacyPowerUps } from 'app/scripts/data/legacy-power-ups';
import { Auth } from 'app/scripts/db/Auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { sendPluginScreenEvent } from 'app/scripts/lib/plugins/plugin-behavioral-analytics';
import { WindowSize } from 'app/scripts/lib/window-size';
import type { Card } from 'app/scripts/models/Card';
import type { BoardView } from 'app/scripts/views/board/BoardView';
import { DirectoryView } from 'app/scripts/views/directory/DirectoryView';
import { pluginRunner } from 'app/scripts/views/internal/plugins/PluginRunner';
import { Dialog } from 'app/scripts/views/lib/Dialog';
import { PluginViewView } from 'app/scripts/views/plugin/PluginViewView';
const CALENDAR_POWER_UP_ID = LegacyPowerUps.calendar;

export const reloadCustomFields = function (this: BoardView) {
  if (this.model.isPluginEnabled(CUSTOM_FIELDS_ID)) {
    // we need to give the server a second to prevent any race conditions
    // mainly if we were the ones to enable custom fields
    return setTimeout(() => {
      return ModelLoader.loadCustomFields(this.model.id);
    }, 1000);
  }
};

export const navigateToBoard = function (this: BoardView) {
  const boardUrl = getBoardUrl(this.model.id);
  return navigate(boardUrl, { trigger: true });
};

export const closeDetailView = function (this: BoardView) {
  Dialog.hide(true);
  this.closeCalendar(false);
  this.closeDirectory(false);
  this.closeMap(false);
  this.closeButler(false);
  this.closeSingleBoardView();
  this.closePowerUpView(false);
};

export const clickCloseDirectory = function (this: BoardView) {
  if (this.directoryView) {
    Analytics.sendClickedButtonEvent({
      buttonName: 'boardDirectoryCloseButton',
      attributes: {
        boardId: this.model.id,
        organizationId: this.model.get('idOrganization'),
      },
      source: this.directoryView.activeEventSource(),
    });
  }

  return this.toggleDirectory();
};

export const toggleDirectory = function (this: BoardView) {
  if (this.directoryView) {
    if (this.directoryReturnCard) {
      this.closeDirectory(false);
      Controller.showCardDetail(this.directoryReturnCard);
      return (this.directoryReturnCard = null);
    } else {
      return this.navigateToBoard();
    }
  } else {
    return this.navigateToDirectory();
  }
};

export const navigateToDirectory = function (
  this: BoardView,
  returnCard?: Card,
) {
  const directoryUrl = getBoardUrl(this.model.id, 'power-ups');
  navigate(directoryUrl, { trigger: true });

  this.directoryReturnCard = returnCard;

  // Close the sidebar menu for window sizes that aren't extra large.
  // @ts-expect-error TS(2339): Property 'fExtraLarge' does not exist on type '{ c... Remove this comment to see the full error message
  if (!WindowSize.fExtraLarge) {
    return this.sidebarView.hideSidebar();
  }
};

export const showDirectory = function (
  this: BoardView,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  section: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  category: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  idPlugin: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isEnabling: any,
) {
  $('#board', this.$el).addClass('hide');

  this.directoryView = new DirectoryView({
    model: this.model,
    section,
    category,
    idPlugin,
    isEnabling,
    boardView: this,
  });
  return $('.js-board-view-container', this.$el).html(
    this.directoryView.render().el,
  );
};

export const closeDirectory = function (
  this: BoardView,
  // eslint-disable-next-line @typescript-eslint/no-shadow
  navigateToBoard?: boolean,
) {
  if (navigateToBoard == null) {
    navigateToBoard = true;
  }
  if (this.directoryView != null) {
    this.directoryView.remove();
    this.directoryView = null;
    if (navigateToBoard) {
      this.navigateToBoard();
    }
    $('#board', this.$el).removeClass('hide');
    $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
  }
};

export const toggleCalendar = function (this: BoardView) {
  if (this.calendarView) {
    if (this.calendarReturnCard) {
      this.closeCalendar(false);
      Controller.showCardDetail(this.calendarReturnCard);
      return (this.calendarReturnCard = null);
    } else {
      return this.navigateToBoardEvent();
    }
  } else {
    return this.navigateToCalendarEvent();
  }
};

export const dismissFeedback = function (this: BoardView) {
  Auth.me().setPluginDataByKey(
    CALENDAR_POWER_UP_ID,
    'private',
    'dismissedFeedback',
    true,
  );
  $('.calendar-header-toolbar-feedback', this.$el).addClass('hide');
};

export const navigateToCalendarEvent = function (this: BoardView) {
  sendPluginScreenEvent({
    idPlugin: LegacyPowerUps.calendar,
    idBoard: this.model.id,
    screenName: 'calendarViewScreen',
  });
  return this.navigateToCalendar();
};

export const navigateToCalendar = function (
  this: BoardView,
  returnCard?: Card,
) {
  this.calendarReturnCard = returnCard;
  const calendarBoardUrl = getBoardUrl(this.model.id, 'calendar');
  return navigate(calendarBoardUrl, { trigger: true });
};

export const navigateToBoardEvent = function (this: BoardView) {
  return this.navigateToBoard();
};

export const isShowingCalendar = function (this: BoardView) {
  return this.calendarView != null;
};

export const showCalendar = function (this: BoardView, date: string) {
  if (!this.model.isPowerUpEnabled('calendar') || this.isShowingCalendar()) {
    return;
  }

  $('.calendar-btn', this.$el).addClass('board-header-btn-enabled');
  $('#board', this.$el).addClass('hide');

  return importWithRetry(
    () =>
      import(
        /* webpackChunkName: "calendar-controller-view" */ 'app/scripts/views/calendar/CalendarControllerView'
      ),
  ).then(({ CalendarControllerView }) => {
    this.calendarView = new CalendarControllerView({
      model: this.model,
    });
    $('.js-board-view-container', this.$el).html(
      this.calendarView.render(date).el,
    );
    this.calendarView.addedToDOM();
  });
};

export const closeCalendar = function (
  this: BoardView,
  // eslint-disable-next-line @typescript-eslint/no-shadow
  navigateToBoard?: boolean,
) {
  if (navigateToBoard == null) {
    navigateToBoard = true;
  }
  if (this.calendarView != null) {
    this.calendarView.remove();
    this.calendarView = null;
    if (navigateToBoard) {
      this.navigateToBoard();
    }
    $('.calendar-btn', this.$el).removeClass('board-header-btn-enabled');
    $('#board', this.$el).removeClass('hide');

    // Hack to resolve a bug where the lists won't have been
    // sized properly if the calendar was visible on initial
    // render (and the board and it's lists were hidden)
    $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
  }
};

export const navigateToMap = function (
  this: BoardView,

  centerTo: {
    lat: string;
    long: string;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  returnCard: any,
) {
  this.mapCenterTo = centerTo;
  this.mapReturnCard = returnCard;
  const mapBoardUrl = getBoardUrl(this.model.id, 'map');
  return navigate(mapBoardUrl, { trigger: true });
};

export const showMap = function (
  this: BoardView,
  {
    mapCenterTo,
    zoom,
  }: {
    mapCenterTo: {
      lat: string;
      long: string;
    };
    zoom: number;
  },
) {
  if (!this.model.isMapPowerUpEnabled() || this.mapView != null) {
    return;
  }

  $('.js-map-btn', this.$el).addClass('board-header-btn-enabled');
  $('#board', this.$el).addClass('hide');

  return importWithRetry(
    () =>
      import(
        /* webpackChunkName: "map-view" */ 'app/scripts/views/map/MapView'
      ),
  ).then(({ MapView }) => {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow */
    const render = (mapCenterTo: any, zoom: any) => {
      this.mapView = new MapView({
        model: this.model,
        mapCenterTo: mapCenterTo ?? this.mapCenterTo,
        zoom: zoom ?? this.zoom,
      });
      $('.js-board-view-container', this.$el).html(this.mapView.render().el);
    };

    // Re-initializes map view when theme changes.
    this.globalThemeObserver = new GlobalThemeObserver(() => {
      if (this.mapView) {
        render(this.mapView.mapCenterTo, this.mapView.zoom);
      }
    });

    render(mapCenterTo, zoom);
  });
};

// eslint-disable-next-line @typescript-eslint/no-shadow
export const closeMap = function (this: BoardView, navigateToBoard?: boolean) {
  if (this.globalThemeObserver) {
    this.globalThemeObserver.unsubscribe();
  }
  if (navigateToBoard == null) {
    navigateToBoard = true;
  }
  if (this.mapView != null) {
    this.mapView.remove();
    this.mapView = null;
    this.mapCenterTo = null;
    if (navigateToBoard) {
      this.navigateToBoard();
    }
    $('.js-map-btn', this.$el).removeClass('board-header-btn-enabled');
    $('#board', this.$el).removeClass('hide');
    $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
  }
};

export const showDashboard = async function (this: BoardView) {
  $('#board', this.$el).addClass('hide');

  const board = this.model;

  const hasViewsFeature = board.isFeatureEnabled(PremiumFeature.Views);

  const canShowDashboard = hasViewsFeature;

  if (canShowDashboard) {
    const { BoardDashboardView } = await importWithRetry(
      () =>
        import(
          /* webpackChunkName: "board-dashboard-view" */ 'app/src/components/BoardDashboardView'
        ),
    );
    renderComponent(
      <BoardDashboardView
        idBoard={board.id}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToBoardView={this.navigateToBoard.bind(this)}
      />,
      // @ts-expect-error TS(2345): Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
      $('.js-board-view-container', this.$el).get(0),
    );
  } else {
    this.navigateToBoard();
  }
};

export const showPowerUpView = async function (
  this: BoardView,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { idPlugin, viewKey }: any,
) {
  if (!this.model.isPluginEnabled(idPlugin)) {
    return;
  }

  const availableViews = await pluginRunner.one({
    plugin: idPlugin,
    command: 'board-views',
    board: this.model,
  });

  // @ts-expect-error TS(2571): Object is of type 'unknown'.
  const selectedView = availableViews.find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (availableView: any) => availableView.key === viewKey,
  );

  if (!selectedView) {
    console.warn('Power-Up View not found.');
    this.navigateToBoard();
    return;
  }

  // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
  this.pluginView = new PluginViewView({
    model: this.model,
    content: selectedView,
  });

  $('#board', this.$el).addClass('hide');
  $('.js-board-view-container', this.$el).html(this.pluginView.render().el);
};

export const closePowerUpView = function (
  this: BoardView,
  // eslint-disable-next-line @typescript-eslint/no-shadow
  navigateToBoard?: boolean,
) {
  if (navigateToBoard == null) {
    navigateToBoard = true;
  }
  if (this.pluginView != null) {
    this.pluginView.remove();
    this.pluginView = null;
    if (navigateToBoard) {
      this.navigateToBoard();
    }
    $('#board', this.$el).removeClass('hide');
    $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
  }
};

export const navigateToButler = function (this: BoardView) {
  const butlerBoardUrl = getBoardUrl(this.model.id, 'butler');
  return navigate(butlerBoardUrl, { trigger: true });
};

/**
 * Navigates the user to butler-client for a given board with optional parameters
 * @param {string} idBoard the id of the board
 * @param {Object} [obj] optional Butler parameters
 * @param {ButlerTab | undefined} [obj.tab] the Butler tab to open
 * @param {string | undefined} [obj.edit] the Butler automation to open in edit mode
 * @param {string | undefined} [obj.log] the Butler automation log to open
 * @param {string | undefined} [obj.newCommand] the string (lz-compressed or not) for a new Butler automation
 * @param {string | undefined} [obj.newIcon] the icon for a new Butler automation
 * @param {string | undefined} [obj.newLabel] the label for a new Butler automation
 * @param {string | undefined} [obj.taskId] the traceId of a capability to track opening the dashboard
 * @param {string | undefined} [obj.source] the source for the capability
 * @param {boolean} [trigger=true] whether to trigger navigation or just update the url
 */
export const navigateToButlerView = function (
  this: BoardView,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any,
  trigger?: boolean,
) {
  // Since we defined type this:any in the function signature, we need to move
  // the defaults out of the signature to avoid incorrect TS transpilation
  const {
    tab,
    log,
    usage,
    account,
    newCommand,
    newIcon,
    newLabel,
    taskId,
    source,
  } = options || {};
  let edit = options?.edit;
  trigger = trigger !== undefined ? trigger : true;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const params = {} as { [key: string]: any };
  if (newCommand) {
    params['c'] = newCommand;
    edit = 'new';
    if (newIcon) {
      params['i'] = newIcon;
    }
    if (newLabel) {
      params['l'] = newLabel;
    }
  }
  if (taskId) {
    params['taskId'] = taskId;
    params['source'] = source;
  }
  const butlerUrl = getButlerUrl(this.model.id, {
    tab,
    edit,
    log,
    usage,
    account,
  });
  const paramsString =
    newCommand || taskId ? `?${new URLSearchParams(params).toString()}` : '';
  navigate(`${butlerUrl}${paramsString}`, { trigger });
};

const getButlerUrl = function (
  idBoard: string,
  { tab = null, edit = null, log = null, usage = null, account = null } = {},
) {
  const extras = [];
  if (tab) {
    extras.push(tab);
  }
  if (edit && edit === 'new' && tab) {
    extras.push('new');
  } else if (edit) {
    extras.push('edit', edit);
  } else if (log) {
    extras.push('log', log);
  } else if (usage) {
    extras.push('usage', usage);
  } else if (account) {
    extras.push('account', account);
  }
  const boardUrl = getBoardUrl(idBoard, 'butler', extras);
  return boardUrl;
};

function isButlerViewActive(this: BoardView) {
  return !!this.butlerView;
}
export { isButlerViewActive };

/**
 * Toggles the display of butler-client. If currently displayed, this will
 * close it; otherwise this will open it to the default tab
 */
export const toggleButlerView = function (this: BoardView) {
  if (this.butlerView) {
    return this.closeButler();
  }
  const butlerUrl = getButlerUrl(this.model.id);
  return navigate(butlerUrl, { trigger: true });
};

/**
 * Creates and renders the butler view
 * this should only be called by showButlerView
 * @param {string} url iframe url for butler-client
 * @param {string | undefined} [taskId] the traceId of a capability to track opening the dashboard
 * @param {string | undefined} [source] the source for the capability
 */
export const setButlerView = function (
  this: BoardView,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  url: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  taskId: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  source: any,
) {
  if (!isUrl(url)) {
    this.navigateToBoard();
    return;
  }
  $('#board', this.$el).addClass('hide');
  return importWithRetry(
    () =>
      import(
        /* webpackChunkName: "butler-view" */ 'app/scripts/views/butler/ButlerView'
      ),
  ).then(({ ButlerView }) => {
    if (this.butlerView) {
      this.butlerView.remove();
    }
    this.butlerView = new ButlerView({ butlerUrl: url });
    $('.board-canvas', this.$el).append(this.butlerView.render().el);
    if (taskId && source) {
      Analytics.taskSucceeded({
        taskName: 'view-butlerDashboard',
        traceId: taskId,
        source: source,
      });
    }
  });
};

/**
 * Retrieves the iframe url for butler-client
 * this should only be called by showBoardDetailView.
 * To open butler-client from elsewhere, either navigateToButlerView or
 * toggleButlerView should be used
 * @param {Object} [obj] optional Butler parameters
 * @param {string} [obj.butlerTab] the Butler tab to open
 * @param {string} [obj.butlerCmdEdit] the Butler automation to open in edit mode
 * @param {string} [obj.butlerCmdLog] the Butler automation log to open
 * @param {string} [obj.newCommand] the string (lz-compressed or not) for a new Butler automation
 * @param {string} [obj.newIcon] the icon for a new Butler automation
 * @param {string} [obj.newLabel] the label for a new Butler automation
 * @param {string | undefined} [obj.taskId] the traceId of a capability to track opening the dashboard
 * @param {string | undefined} [obj.source] the source for the capability
 */
export const showButlerView = function (
  this: BoardView,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any,
) {
  // Since we defined type this:any in the function signature, we need to move
  // the defaults out of the signature to avoid incorrect TS transpilation
  const {
    butlerTab,
    butlerCmdEdit,
    butlerCmdLog,
    newCommand,
    butlerUsage,
    butlerAccount,
    newIcon,
    newLabel,
    taskId,
    source,
  } = options || {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let traceId: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let traceSource: any;
  if (this.butlerView != null) {
    return;
  }
  if (!this.model.editable()) {
    this.navigateToBoardEvent();
    return;
  }
  if (taskId) {
    // get rid of the taskId/source url parameters
    this.navigateToButlerView(
      {
        tab: butlerTab,
        edit: butlerCmdEdit,
        log: butlerCmdLog,
        usage: butlerUsage,
        account: butlerAccount,
        newCommand,
        newIcon,
        newLabel,
      },
      false,
    );
    traceId = taskId;
    traceSource = source;
  } else {
    // no task Id, so this was probably a deep link
    traceSource = 'boardScreen';
    traceId = Analytics.startTask({
      taskName: 'view-butlerDashboard',
      source: traceSource,
    });
  }
  pluginRunner
    .one({
      plugin: BUTLER_POWER_UP_ID,
      command: 'show-settings',
      board: this.model,
      options: {
        butlerTab,
        butlerCmdEdit,
        butlerCmdLog,
        butlerUsage,
        butlerAccount,
        newCommand,
        newIcon,
        newLabel,
      },
    })
    .then((res) => {
      const showButler = this.model.canShowButlerUI();
      // In the case showButler is true lets open the Butler dashboard
      if (showButler) {
        return this.setButlerView(res, traceId, traceSource);
      }
      // Otherwise let's close the Butler dashboard and redirect them to the
      // board. They will still receive an alert letting them know that the
      // Butler dashboard has been restricted to only enterprise admins by their
      // Enterprise.
      this.closeButler();
      this.navigateToBoard();
    })
    .catch((error) => {
      Analytics.taskFailed({
        taskName: 'view-butlerDashboard',
        traceId: traceId,
        source: traceSource,
        error,
      });
      throw error;
    });
};

export const closeButler = function (
  this: BoardView,
  // eslint-disable-next-line @typescript-eslint/no-shadow
  navigateToBoard?: boolean,
) {
  if (navigateToBoard == null) {
    navigateToBoard = true;
  }
  if (this.butlerView != null) {
    this.butlerView.remove();
    this.butlerView = null;
    if (navigateToBoard) {
      this.navigateToBoard();
    }
    $('#board', this.$el).removeClass('hide');
    $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
  }
};
